<template>
    <div class="contact contain_white">
        <div class="flex">
            <label><i class="el-icon-phone-outline"></i>電話</label>
            <div>037-586610#651</div>
        </div>
        <div class="flex">
            <label><i class="el-icon-mobile"></i>手機</label>
            <div>0932-295-077</div>
        </div>
        <div class="flex">
            <label><i class="el-icon-message"></i>E-mail</label>
            <div>OSHD@playnitride.com</div>
        </div>
    </div>
</template>

<style lang="scss">
.contact {
    >div {
        margin: 20px 10px;

        i {
            padding: 0 10px;
        }
    }

    label {
        width: 130px;
    }
}
</style>
<script>
export default {
    name: "contact",
    data() {
        return {

        }
    },
}
</script>